import { allMessages, defaultMessages } from '@/translations/translations.constants'
import type { TMessages } from '@/translations/translations.types'

export const getMessages = (locale: TLocale) =>
  ({
    ...defaultMessages,
    ...allMessages[locale],
  }) as TMessages
